import React from 'react';
import PropTypes from 'prop-types';

import { Label } from '@atlas/ui';

export const InfoLabel = ({ label }) => (
  <span className="withdrawal-bitcoin__label">
    <Label message={label} />
    {': '}
  </span>
);

InfoLabel.propTypes = {
  label: PropTypes.string.isRequired,
};
